import moment from 'moment';
import React, { FC } from 'react';
import { Controller } from 'react-hook-form';
import styled from 'styled-components';
import { DatePicker } from 'components/atoms/date-picker';
import { API_DATE_FORMAT } from 'components/atoms/due-date-picker';
import {
  FormItemWrapper,
  FormItemDesc,
  FormItemLabel,
  FieldsErrorRenderer,
  FormFieldProps,
} from './form-elements';

const StyledDatePicker = styled(DatePicker)`
  margin-top: var(--spacing-03);
  .ant-picker-clear {
    opacity: 1;
  }
`;

export const DateField: FC<FormFieldProps> = ({
  field,
  control,
  setValue,
  errors,
  disabled,
}) => {
  return (
    <FormItemWrapper>
      <FormItemLabel label={field.questionText} required={field.required} />
      <Controller
        control={control}
        rules={{ required: field.required }}
        name={field.questionId.toString()}
        shouldUnregister
        render={(props) => (
          <StyledDatePicker
            style={{ width: '100%' }}
            ref={props.field.ref}
            value={props.field.value ? moment(props.field.value) : null}
            format={['DD MMM YYYY', 'DD/MM/YYYY', 'D/M/YYYY', 'D/M/YY']}
            placeholder="DD/MM/YYYY"
            disabled={disabled}
            getPopupContainer={(trigger) =>
              trigger.parentElement as HTMLElement
            }
            allowClear
            onChange={(v) => {
              setValue?.(
                field.questionId.toString(),
                v ? v.format(API_DATE_FORMAT) : null,
              );
            }}
          />
        )}
      />

      <FieldsErrorRenderer errors={errors} questionId={field.questionId} />
      <FormItemDesc label={field.description} />
    </FormItemWrapper>
  );
};
